import { Outlet } from "react-router-dom";

import Navbar from "../Navbar";
import Footer from "../Footer";
import OrganizationSchema from "../../../components/SEO/SchemaMarkup/Organization";
import NavigationSchema from "../../../components/SEO/NavigationSchema";
import BreadcrumbSchema from "../../../components/SEO/BreadcrumbSchema";

const Layout = ({ ...props }) => {
  return (
    <>
      <OrganizationSchema />
      <NavigationSchema />
      <BreadcrumbSchema />
      <Navbar {...props} />
      <main className="relative bg-white">
        <Outlet />
      </main>
      <Footer/>
    </>
  );
};

export default Layout;
